// extracted by mini-css-extract-plugin
export default {"container":"DisplayComponentError_container__5s1-G"};